/**
 * Splits an array into two based on a passed predicate
 *
 * @param array
 * @param predicate
 * @returns an array containing two arrays
 */
export function split<T>(array: T[], predicate: (value: T) => boolean): [T[], T[]] {
	return array.reduce<[T[], T[]]>(
		(acc, value) => {
			if (predicate(value)) {
				acc[0].push(value)
			} else {
				acc[1].push(value)
			}
			return acc
		},
		[[], []],
	)
}

/**
 * Converts a flat array into an array of tuples
 * eg [
 *  [a[0], a[1]],
 *  [a[2], a[3]]
 * ]
 *
 * @param array
 * @param predicate
 * @returns an array containing consecutive tuples
 */
export function splitIntoTuples<T>(array: T[]): [T, T][] {
	return array.reduce(
		(acc, _, index, arr) => {
			if (index % 2 === 0 && index + 1 < array.length) {
				const tuple = [arr[index], arr[index + 1]] as [T, T]
				acc.push(tuple)
			}
			return acc
		},
		[] as [T, T][],
	)
}
